class ExtendedForm extends HTMLElement {
    constructor() {
        super();
        this.isUpdating = false;
        this.debounceTimeout = null; // Add a debounce timeout
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.form = this.querySelector('form');

        this.formSelector = this.dataset.form;
        this.updateExtendedForm();

        this.form.addEventListener('change', this.handleChange.bind(this));

        /* this.extendedForms.forEach((form) => {
            form.addEventListener('change', this.handleChange.bind(this));
        }); */
    }

    updateExtendedForm() {
        this.extendedForm = document.querySelector(this.formSelector);
    }

    handleChange(e) {
        clearTimeout(this.debounceTimeout); // Clear the previous timeout
        this.debounceTimeout = setTimeout(() => {
            if (this.isUpdating) return;
            this.isUpdating = true;

            let sourceForm = e.target;
            while (sourceForm && sourceForm.tagName !== 'FORM') {
                sourceForm = sourceForm.parentElement;
            }

            if (!sourceForm) {
                this.isUpdating = false;
                return;
            }

            if (sourceForm === this.form) {
                /* this.extendedForms.forEach((form) => this.applyFormData(form, sourceForm)); */
                this.applyFormData(this.extendedForm, sourceForm);
            } else {
                this.applyFormData(this.form, sourceForm);
            }

            const detailsElement = this.closest('details');
            if (detailsElement) {
                detailsElement.removeAttribute('open');
            }

            this.isUpdating = false;
        }, 300); // Adjust the debounce delay as needed
    }

    applyFormData(targetForm, sourceForm) {
        const sourceInputs = sourceForm.querySelectorAll('input, select, textarea');
        sourceInputs.forEach((input) => {
            const targetInput = targetForm.querySelector(`[name="${input.name}"]`);

            if (input.type === 'checkbox' || input.type === 'radio') {
                const targetCheckbox = targetForm.querySelector(
                    `[name="${input.name}"][value="${input.value}"]`
                );
                if (targetCheckbox) {
                    targetCheckbox.checked = input.checked;
                }
            } else if (targetInput) {
                targetInput.value = input.value;
            }
        });

        targetForm.dispatchEvent(new InputEvent('input'));
    }
}

customElements.define('extended-form', ExtendedForm);
